export class ScwsError extends Error {}

export class NoReaderChosenError extends ScwsError {
  constructor() {
    super("No reader chosen");
  }
}
